import React, { Suspense, useEffect } from "react";
import parse, { domToReact } from "html-react-parser";

export default (components, html) => {
	function replacer({ attribs, children }) {
		if (attribs && attribs["data-react"]) {
			if (!components[attribs["data-react"]]) return;
			const Component = components[attribs["data-react"]];
			const propsString = attribs["data-props"];
			const props = !!propsString ? JSON.parse(propsString) : {};
			const emptyChildrenRemoved = children.filter((child) => {
				return (
					child.type !== "text" ||
					(child.type === "text" && child.data.trim().length)
				);
			});
			const Comp = (
				<Component {...props}>
					{domToReact(emptyChildrenRemoved, { replace: replacer })}
				</Component>
			);
			return Comp;
		}
	}
	let comp = parse(html, { replace: replacer });
	const Fallback = ({ html }) => {
		useEffect(() => {
			return () => console.log("Fallback unmounted");
		});
		return <div dangerouslySetInnerHTML={{ __html: html }} />;
	};
	return <Suspense fallback={<Fallback html={html} />}>{comp}</Suspense>;
};
